import { HostListener, Injectable } from '@angular/core';
import { Observable, Subject, Subscription, interval } from 'rxjs';
import { debounce } from 'lodash';
import { throttle } from 'rxjs/operators';

@Injectable()
export class UserActivityService {
  private timeoutInSeconds = 15; 
  private lastActivity?: Date;
  private idleCheckIntervalInSeconds = 5; 

  private onInactiveCallback: () => void; 

  constructor() {
    this.resetTimer();
    this.startWatching();

    this.debouncedRefreshUserState = this.debouncedRefreshUserState.bind(this);
  }

  public init(timeoutInMinutes: number, inActiveCallback: () => void) {
    this.onInactiveCallback = inActiveCallback;
    this.timeoutInSeconds = timeoutInMinutes * 60;
  }

  private startWatching(): void {
    setInterval(() => {
      const now = new Date();

      if (now.getTime() - this.lastActivity?.getTime()! > this.timeoutInSeconds * 1000) {

        if (this.onInactiveCallback === undefined) {
          throw new Error("Please call init with callback before using this method");
        }

        this.onInactiveCallback();
      }
    }, this.idleCheckIntervalInSeconds * 1000);

  }

  debouncedRefreshUserState = debounce(() => {
    this.lastActivity = new Date();
  }, 500);

  resetTimer(): void {
    this.debouncedRefreshUserState();
  }
}
